import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useDateTimeFormat } from './use_date_time_format';
/**
 * DateTimeFormat displays a localized, formatted date for instant or zoned values.
 */
export const DateTimeFormat = (props) => {
    const { dataTestId, date, timeZone, variant, dateOnly, showSeconds, showTimeZoneName } = props, rest = __rest(props, ["dataTestId", "date", "timeZone", "variant", "dateOnly", "showSeconds", "showTimeZoneName"]);
    const { formatDateTime, formatDateTimeWithZone, formatPlainDate } = useDateTimeFormat();
    const isPlainDate = variant === 'plain-date';
    const isZoned = variant === 'zoned';
    const formattedValue = isPlainDate
        ? formatPlainDate(date)
        : isZoned
            ? formatDateTimeWithZone(date, {
                dateOnly,
                timeZone: timeZone,
                showTimeZoneName,
                showSeconds,
            })
            : formatDateTime(date, { dateOnly, showSeconds });
    return (_jsx("span", Object.assign({ "data-testid": dataTestId }, rest, { children: formattedValue })));
};
//# sourceMappingURL=date_time_format.js.map